import React from 'react';
import { useI18n } from '../../../context/I18nContext';
import './menu-search.css';

interface SidebarMenuSearchProps {
    value: string;
    onChange: (value: string) => void;
}

/** Yan menunun ustundeki arama kutusu (Faz 2.3). Suzme `menu-search.ts` icinde. */
const SidebarMenuSearch = ({ value, onChange }: SidebarMenuSearchProps) => {
    const { t } = useI18n();

    return (
        <div className="wc-menu-search" role="search">
            <i className="fa-solid fa-magnifying-glass wc-menu-search-icon" aria-hidden="true" />
            <input
                type="text"
                className="wc-menu-search-input"
                value={value}
                placeholder={t('menuSearch.placeholder')}
                aria-label={t('menuSearch.placeholder')}
                autoComplete="off"
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Escape') onChange('');
                }}
            />
            {value ? (
                <button
                    type="button"
                    className="wc-menu-search-clear"
                    aria-label={t('menuSearch.clear')}
                    onClick={() => onChange('')}
                >
                    <i className="fa-solid fa-xmark" aria-hidden="true" />
                </button>
            ) : null}
        </div>
    );
};

export default SidebarMenuSearch;
